import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function EventsLists() {
  const [eventsLists, setEventsLists] = useState([]);

  useEffect(() => {
    const fetchEventsLists = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/events/event-inner-pages`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setEventsLists(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchEventsLists();
  }, []);

  const renderRow = (events, layoutType) => {
    switch (layoutType) {
      case "8-4": // First row layout
        return (
          <Row key={`row-${events[0]?.id}`}>
            <Col md={8}>
              <Link to={`/events/${events[0]?.slug}`}>
                <div className="events-list-img">
                  <img
                    src={`${apiUrl.apiUrl}/${events[0]?.center_image}`}
                    className="img-fluid mb-3"
                    alt="Apartments for sale in Dubai"
                    data-aos="fade-right"
                  />
                </div>
              </Link>
            </Col>
            {events[1] && (
              <Col md={4}>
                <div className="events-list-img">
                  <Link to={`/events/${events[1]?.slug}`}>
                    <img
                      src={`${apiUrl.apiUrl}/${events[1]?.center_image}`}
                      className="img-fluid mb-3"
                      alt="Premium properties in Dubai"
                      data-aos="fade-left"
                    />
                  </Link>
                  <p className="common-para" data-aos="fade-left">
                    {events[1]?.event_title}
                  </p>
                  <Link
                    to={`/events/${events[1]?.slug}`}
                    className="marquis-roundededge-button"
                  >
                    Read More
                  </Link>
                </div>
              </Col>
            )}
          </Row>
        );
      case "12": // Single column layout
        return (
          <Row key={`row-${events[0]?.id}`}>
            <Col md={12}>
              <div className="events-list-img">
                <Link to={`/events/${events[0]?.slug}`}>
                  <img
                    src={`${apiUrl.apiUrl}/${events[0]?.center_image}`}
                    className="img-fluid mb-3"
                    alt="Luxury real estate Developer Dubai"
                    data-aos="fade-right"
                  />
                </Link>
                <p className="common-para" data-aos="fade-left">
                  {events[0]?.event_title}
                </p>
                <Link
                  to={`/events/${events[0]?.slug}`}
                  className="marquis-roundededge-button"
                >
                  Read More
                </Link>
              </div>
            </Col>
          </Row>
        );
      case "7-5": // Third row layout
        return (
          <Row key={`row-${events[0]?.id}`}>
            <Col md={7}>
              <div className="events-list-img">
                <Link to={`/events/${events[0]?.slug}`}>
                  <img
                    src={`${apiUrl.apiUrl}/${events[0]?.center_image}`}
                    className="img-fluid mb-3"
                    alt="Dubai property for sale"
                    data-aos="fade-right"
                  />
                </Link>
                <p className="common-para" data-aos="fade-left">
                  {events[0]?.event_title}
                </p>
                <Link
                  to={`/events/${events[0]?.slug}`}
                  className="marquis-roundededge-button"
                >
                  Read More
                </Link>
              </div>
            </Col>
            {events[1] && (
              <Col md={5}>
                <div className="events-list-img">
                  <Link to={`/events/${events[1]?.slug}`}>
                    <img
                      src={`${apiUrl.apiUrl}/${events[1]?.center_image}`}
                      className="img-fluid mb-3"
                      alt="Apartment to buy in Dubai"
                      data-aos="fade-left"
                    />
                  </Link>
                  <p className="common-para" data-aos="fade-left">
                    {events[1]?.event_title}
                  </p>
                  <Link
                    to={`/events/${events[1]?.slug}`}
                    className="marquis-roundededge-button"
                  >
                    Read More
                  </Link>
                </div>
              </Col>
            )}
          </Row>
        );
      default:
        return null;
    }
  };

  const rows = [];
  for (let i = 0; i < eventsLists.length;) {
    if (i + 2 <= eventsLists.length) {
      rows.push(renderRow(eventsLists.slice(i, i + 2), "8-4")); // First row
      i += 2;
    }
    if (i + 1 <= eventsLists.length) {
      rows.push(renderRow(eventsLists.slice(i, i + 1), "12")); // Second row
      i += 1;
    }
    if (i + 2 <= eventsLists.length) {
      rows.push(renderRow(eventsLists.slice(i, i + 2), "7-5")); // Third row
      i += 2;
    }
    if (i + 1 <= eventsLists.length) {
      rows.push(renderRow(eventsLists.slice(i, i + 1), "12")); // Fifth row
      i += 1;
    }
  }

  return (

    <section className="events-list-sec">
      <Container fluid>{rows}</Container>
    </section>

  );
}

export default EventsLists;
